import { IonCard, IonCardContent, IonCol, IonGrid, IonRow } from '@ionic/react';
import { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  ExportableDataType,
  useRequestExportMutation,
} from '../../api/graphql/generated';
import { useCurrentUser } from '../../api/user.hooks';
import { trackRequestedTenantExport } from '../../config/analytics';
import { RightAlignedButtons } from '../button/aligned-buttons';
import { LoadingButton } from '../button/loading-button';
import { SaveStatusToast } from '../toast/toast.gql';

const TenantExport = (): ReactElement => {
  const { i18n } = useTranslation();

  const currentUser = useCurrentUser();

  const [
    requestExport,
    { loading: requestExportLoading, error: requestExportError },
  ] = useRequestExportMutation();

  const handleRequestExportButtonClick = async (): Promise<void> => {
    const requestedDataTypes = [
      ExportableDataType.MACHINES,
      ExportableDataType.MACHINE_EVENTS,
      ExportableDataType.SCRATCHPADS,
      ExportableDataType.TEAMS,
      ExportableDataType.TEAM_USERS,
      ExportableDataType.USERS,
    ];

    trackRequestedTenantExport({
      dataTypes: requestedDataTypes,
    });

    await requestExport({
      variables: {
        input: {
          dataTypes: requestedDataTypes,
        },
      },
    });
  };

  return (
    <>
      <IonGrid>
        <IonRow class="ion-align-items-stretch">
          <IonCol
            size="6"
            sizeXs="12"
            sizeLg="6"
            sizeXl="6"
            class="ion-align-self-stretch"
          >
            <IonCard>
              <IonCardContent>
                <p>
                  {/* Had to use Trans cmp to render HTML in message */}
                  <Trans>
                    {i18n.t('common:export_data_info', {
                      email: currentUser?.email,
                    })}
                  </Trans>
                </p>
                <br />
                <RightAlignedButtons>
                  <LoadingButton
                    loading={requestExportLoading ?? false}
                    buttonProps={{
                      size: 'default',
                      slot: 'end',
                      onClick: (e) => {
                        e.preventDefault();
                        handleRequestExportButtonClick();
                      },
                    }}
                  >
                    {i18n.t('common:export_data')}
                  </LoadingButton>
                </RightAlignedButtons>
              </IonCardContent>
            </IonCard>
            <SaveStatusToast
              loading={requestExportLoading}
              error={requestExportError}
              defaultMessageKey={'common:exporting'}
              defaultErrorMessageKey={'common:export_error'}
            />
          </IonCol>
        </IonRow>
      </IonGrid>
    </>
  );
};

export { TenantExport };
